import React from "react";

export function FiltroTipoRelacionamento({ onChange, value }) {
  const onValueChange = (e) => {
    onChange(e.target.value);
  }

  return (
    <div className="form">
      <div className="form__grupo">
        <label className="grid-4 margem-direita-1">
          <input type="radio" value={'AlegoShared::Sgu::Usuario'} name="tipo_relacionamento" checked={value == 'AlegoShared::Sgu::Usuario'} onChange={onValueChange} />
          <span className="label texto-normal">Pessoa</span>
        </label>

        <label className="grid-4 margem-direita-1">
          <input type="radio" value={'AlegoShared::Public::Lotacao'} name="tipo_relacionamento" checked={value == 'AlegoShared::Public::Lotacao'}  onChange={onValueChange} />
          <span className="label texto-normal">Lotação</span>
        </label>

        <label className="grid-4 margem-direita-1">
          <input type="radio" value={'AlegoShared::Pessoal::Cargo'} name="tipo_relacionamento" checked={value == 'AlegoShared::Pessoal::Cargo'} onChange={onValueChange} />
          <span className="label texto-normal">Cargo</span>
        </label>
      </div>
    </div>
  )
}